import React from "react";
import VideoPlayer from "./VideoPlayer";
import WidgetPlayer from "./WidgetPlayer";
import DesmosPlayer from "./DesmosPlayer";
import ScorcherPlayer from "./ScorcherPlayer";

const MediaPlayer = props => {
    const {mediaId, mediaType, conceptId, stepId} = props;

    if (!mediaId && (!['DESMOS', 'SCORCHER'].includes(mediaType))) {
        return <div className={'ch-warning-text'}>No media found</div>
    }

    return (
        <>
            {mediaType === 'WIDGET' &&
                <WidgetPlayer mediaId={mediaId} conceptId={conceptId} />
            }
            {mediaType === 'VIDEO' &&
                <VideoPlayer mediaId={mediaId} conceptId={conceptId} displayInDialog={true} />
            }
            {mediaType === 'DESMOS' &&
                <DesmosPlayer mediaId={mediaId} conceptId={conceptId} />
            }
            {mediaType === 'SCORCHER' &&
                <ScorcherPlayer stepId={stepId} />
            }
        </>
    )

}

export default MediaPlayer;